import Button from '@/common/components/base/button/Button';
import LoadingButton from '@/common/components/base/button/loadingButton';
import MobileInput from '@/common/components/base/input/mobileInput/MobileInput';
import { MOBILE_NUMBER_RULE } from '@/common/components/base/input/mobileInput/mobileInput.rules';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import { ADDRESS_RULE } from '@/common/utils/rules/address.rules';
import { PHONE_NUMBER_RULE } from '@/common/utils/rules/phoneNumber.rules';
import { POSTAL_CODE_RULE } from '@/common/utils/rules/postalCode.rules';
import { requiredText } from '@/common/utils/rules/publicRules';
import { ADJUSTER_REPORT_DAMAGED_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import ConfirmDriverModal from '@/modules/adjusterReportModules/IncidentParticipants/components/modals/ConfirmDriverModal';
import { DriverInfoTypeForm } from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/driver-owner/driverInfo/driverInfo.type';
import { useDriverContactQuery } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchContactDriverData/patchContactDriverQueryOptions';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

const ContactInfo: React.FC = () => {
  const methods = useFormContext<DriverInfoTypeForm>();
  const isOwnerDriver = methods?.watch('personal_information.is_owner_driver');
  const phoneNumber = useWatch({
    control: methods.control,
    name: 'contact_information.phone',
  });
  const [openModal, setOpenModal] = React.useState(false);
  const loading = false;
  const { mutate: patchDriverContactInfo } = useDriverContactQuery();
  const { id, damagedId } = useParams();
  const navigate = useNavigate();
  const onSubmit = (formData: DriverInfoTypeForm) => {
    patchDriverContactInfo(
      {
        damaged_id: Number(damagedId),
        id: Number(id),
        data: {
          ...formData.contact_information,
          city_code:
            formData.contact_information?.city_code === ''
              ? null
              : formData.contact_information?.city_code,
          postal_code:
            formData.contact_information?.postal_code === ''
              ? null
              : formData.contact_information?.postal_code,
        },
      },
      {
        onSuccess: () => {
          isOwnerDriver === 'false' ? setOpenModal(true) : navigate(-1);
        },
      },
    );
  };
  const previousStep = () => {
    navigate(
      ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
        damagedId: +damagedId!,
        id: +id!,
      }).DRIVER_OWNER_INFORMATION.certificate,
      { replace: true },
    );
  };
  return (
    <Flex direction="column" gap={32}>
      {isOwnerDriver === 'false' && (
        <ConfirmDriverModal
          open={openModal}
          setOpenModal={setOpenModal}
          cancelNavigate={() => navigate(-1)}
          navigateTo={() => {
            navigate(
              ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
                id: +id!,
                damagedId: +damagedId!,
              }).DRIVER_OWNER_INFORMATION.owner,
              { replace: true },
            );
          }}
        />
      )}
      <Box>
        <MobileInput
          name="contact_information.phone_number"
          label="تلفن همراه "
          rules={{ required: requiredText, ...MOBILE_NUMBER_RULE }}
        />
      </Box>
      <Box display="flex" flexDirection="row" gap="10px">
        <Box flexBasis={'80%'}>
          <TextInput
            name="contact_information.phone"
            label="تلفن ثابت"
            placeholder="XX-XX-XX-XX"
            direction="ltr"
            key={'phone'}
            noCharInput={true}
            rules={{ ...PHONE_NUMBER_RULE, required: requiredText }}
            max={8}
          />
        </Box>
        <Box flexBasis={'30%'}>
          <TextInput
            name="contact_information.city_code"
            key={'city_code'}
            placeholder="کد شهر"
            noCharInput={true}
            direction="ltr"
            rules={{
              minLength: { message: 'پیش شماره شهر 3 رقمی است', value: 3 },
              required: {
                message: requiredText,
                value: phoneNumber ? true : false,
              },
            }}
            max={3}
          />
        </Box>
      </Box>
      <Box>
        <TextInput
          label="کدپستی"
          name="contact_information.postal_code"
          placeholder="کدپستی را وارد کنید"
          rules={{ ...POSTAL_CODE_RULE }}
          defaultValue=""
          optionalLabel
          noCharInput
          max={10}
        />
      </Box>
      <Box>
        <TextInput
          label="آدرس"
          name="contact_information.address"
          placeholder="آدرس را وارد کنید"
          rules={{ ...ADDRESS_RULE }}
          defaultValue=""
          optionalLabel
        />
      </Box>
      <Flex w="100%" gap={16} mb="1rem">
        <Button fullWidth variant="outlined" onClick={previousStep}>
          مرحله قبل
        </Button>{' '}
        <LoadingButton
          onClick={methods.handleSubmit(onSubmit)}
          loading={loading}
          fullWidth
          disabled={!methods?.formState?.isValid}
        >
          ثبت
        </LoadingButton>
      </Flex>
    </Flex>
  );
};

export default ContactInfo;
